import * as client from "_graphql-types";
import { filterSortPage } from "../DataProvider";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

interface Filter {
  headers?: boolean;
  completeness?: {
    // json stringified [category?, subcategory?]
    column?: string;
    min?: number;
    max?: number;
  };
}

type Investment =
  client.GetListProspectiveInvestmentQuery["investmentList"]["items"][number];

async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InvestmentSortEnum, Filter>
): types.GetListOut<Investment> {
  const { filter, sort, pagination } = params;

  if (filter.headers) {
    const { investmentCompletenessHead: completeness } =
      await sdk.getInvestmentCompletenessHead();
    return {
      total: 1,
      data: [
        {
          id: 0,
          name: "",
          completeness,
        },
      ],
    };
  }

  const searchFilters: client.InvestmentSearchFilters[] = [
    { INVESTMENT_LIST: { values: [{ id: 2, label: "Prospective" }] } },
    { ACCESS: { values: [client.Prud.Preview] } },
  ];
  if (filter.completeness) {
    const { column, min, max } = filter.completeness;
    if (column) {
      const [category, subcategory] = JSON.parse(column) as string[];
      searchFilters.push({
        COMPLETENESS: {
          category,
          subcategory,
          min: typeof min === "number" ? min / 100 : undefined,
          max: typeof max === "number" ? max / 100 : undefined,
        },
      });
    }
  }

  const {
    investmentList: { items: data, total },
  } = await sdk.getListProspectiveInvestment({
    ...filterSortPage({
      sort,
      pagination,
      nameField: client.InvestmentSortEnum.Name,
    }),
    searchFilters,
  });

  return { data, total };
}

export const prospectiveInvestment = types.dataProvider({
  getList,
});
